import { Switch } from '@mui/material';
import { GREY, MAIN_THEME_COLOR } from '../assets/theme/Colors';

interface CustomSwitchProps {
	isChecked: boolean;
	handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

function CustomSwitch({ isChecked, handleChange }: CustomSwitchProps) {
	return (
		<Switch
			checked={isChecked}
			onChange={handleChange}
			sx={{
				'& .MuiSwitch-switchBase': {
					color: GREY,
					'&:hover': {
						backgroundColor: 'rgba(0, 0, 0, 0.08)',
					},
					'&.Mui-checked': {
						color: MAIN_THEME_COLOR,
						'&:hover': {
							backgroundColor: 'rgba(255, 64, 129, 0.08)',
						},
					},
					'&.Mui-checked + .MuiSwitch-track': {
						backgroundColor: MAIN_THEME_COLOR,
					},
				},
				'& .MuiSwitch-track': {
					backgroundColor: '#E0E0E0',
					'&.Mui-checked': {
						backgroundColor: '#FF4081',
					},
				},
			}}
		/>
	);
}

export default CustomSwitch;
